import $ from 'jquery';
$( function() {
	var currentHref = ensureTrailingSlash(window.location.href);	
	if (currentHref.indexOf( '/en-au/' ) >= 0 ){
		$( 'body' ).on( 'click', 'a', function ( e ){
			var $a = $(this), href = ensureTrailingSlash($a.attr( 'href' ));
			if ( href.indexOf( '/en-au/' ) === -1 && href.indexOf( 'cid=aus-nz' ) === -1 && ( href.indexOf( '/' ) === 0 || href.indexOf( '.ti.com' ) >= 0 ) && href.indexOf( '/media/' ) === -1 && href.indexOf( '/html' ) === -1 && href.indexOf( 'nspire' ) === -1 ){
				if ( !confirm( 'You are about to enter another TI website.' ) ) {
					e.preventDefault();
				}
			}
		});
	}

	function ensureTrailingSlash(url) {
		url = url.toLowerCase();
		return url.endsWith("/en-au") ? url + "/" : url;
	}
} );